import React from 'react';

const NoteTemplate = (props) => {
    console.info(props.entry)
    return (
        <React.Fragment>
            {/* Note entries require no special template since it can simply show the notes properties */}
        </React.Fragment>
    )
}

export default NoteTemplate;